import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { INormativeCell, INormativeRow } from '../../normatives';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-normative-table',
  templateUrl: './normative-table.component.html',
  styleUrls: ['./normative-table.component.scss'],
  standalone: false,
})
export class NormativeTableComponent {
  @Input() headers: string[] = [];
  @Input() rows: INormativeRow[] = [];
  @Input() level: 'country' | 'federal' | 'region' | 'sector';
  @Output() overwrite = new EventEmitter<{ level: string; cells: INormativeCell[]; cascade: boolean }>();

  constructor() {}

  get changedCells(): INormativeCell[] {
    return this.rows.flatMap((row) => row.cells.filter((cell) => cell && cell.isChanged));
  }

  get allCells(): INormativeCell[] {
    return this.rows.flatMap((row) => row.cells.filter((cell) => cell));
  }

  onOverwriteSelected(): void {
    this.overwrite.emit({ level: this.level, cells: this.changedCells, cascade: false });
  }

  onOverwriteAll(): void {
    this.overwrite.emit({ level: this.level, cells: this.allCells, cascade: true });
  }

  formatValue(value: number | null | undefined): string {
    return value === undefined || value === null ? '-' : String(value);
  }

  isTotalCell(colIndex: number): boolean {
    return this.headers[colIndex + 1] === 'База норматив, мин.';
  }

  startEditing(cell: INormativeCell, row: INormativeRow, rowIndex: number, colIndex: number): void {
    if (this.isTotalCell(colIndex)) {
      return;
    }
    cell.isEditing = true;
  }

  cancelEditing(cell: INormativeCell): void {
    cell.value = cell.originalValue;
    cell.isEditing = false;
    cell.isChanged = false;
  }

  saveCell(cell: INormativeCell, row: INormativeRow): void {
    cell.isEditing = false;
    cell.isChanged = cell.value !== cell.originalValue;
  }
}
